import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './my-updates-tab.component'

let module = angular.module('myUpdatesTab', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('vehicle.manageMyRlink.myUpdates.myUpdatesTab', {
      component: 'myUpdatesTab',
      authenticate: true
    })
})

.component('myUpdatesTab', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/my-updates/my-updates-tab/index.js